import React from 'react';

interface FileInputControlProps {
    id: string;
    fileName?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
}

// Native file inputs render "Browse.../No file selected" in the browser's own
// locale, which we can't control via props — so we build a styled substitute.
export const FileInputControl: React.FC<FileInputControlProps> = ({ id, fileName, onChange, disabled }) => (
    <div
        className="d-flex align-items-center"
        style={{
            border: '1px solid #ced4da',
            borderRadius: '4px',
            overflow: 'hidden',
            fontSize: '16px'
        }}
    >
        <label
            htmlFor={id}
            className="mb-0"
            style={{
                padding: '6px 12px',
                backgroundColor: '#e9ecef',
                borderRight: '1px solid #ced4da',
                cursor: disabled ? 'not-allowed' : 'pointer',
                whiteSpace: 'nowrap'
            }}
        >
            Välj fil
        </label>
        <span
            style={{
                padding: '6px 12px',
                color: fileName ? '#212529' : '#6c757d',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }}
        >
            {fileName || 'Ingen fil vald'}
        </span>
        <input
            id={id}
            type="file"
            accept="image/*"
            onChange={onChange}
            disabled={disabled}
            style={{ display: 'none' }}
        />
    </div>
);
